export const awsBasePath = process.env.GATSBY_AWS_ENDPOINT
